import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AuthentificationService } from './authentification-service';
import 'rxjs/add/operator/map';

/*
  Generated class for the PreferencesService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.

  PreferencesService gère tout ce qui a en rapport avec les configurations de l'application
  Pour l'instant elle gère donc les notifications et le fait d'afficher un seul jour ou plusieurs
*/
@Injectable()
export class PreferencesService {

  private pushNotifications : boolean; //True si on accepte les notifications push
  private allWeekMenus : boolean; //True si on affiche toute la semaine plutôt que le jour-même
  //On retourne la valeur du toggle des notifications push
  getTogglePushNotifications()
  {
    return this.pushNotifications;
  }
  //On retourne la valeur du toggle des menus de toute la semaine
  getToggleAllWeekMenus()
  {
    return this.allWeekMenus;
  }
  //on set les notifications push à true ou false
  setPushNotifications(val: boolean)
  {
    let isPushAuthorized = val;
    let deviceOwner = this.authentificationService.getUserId();
    if(deviceOwner === null || deviceOwner === "null")
      isPushAuthorized = false;
    console.log("setPushNotifications "+ val);
    console.log("deviceOwner "+ deviceOwner);
    localStorage.setItem('isPushAuthorized', ""+isPushAuthorized);
    localStorage.setItem('deviceOwner', ""+deviceOwner);
    this.pushNotifications=isPushAuthorized;
  }
  //on set l'affichage des menus de toute la semaine à true ou false
  setAllWeekMenus(val: boolean)
  {
    //console.log("setAllWeekMenus "+val);
    this.allWeekMenus=val;
  }
  constructor(public http: Http, public authentificationService: AuthentificationService) {
    console.log('Hello PreferencesService Provider');
    
    var isPushAuthorized = localStorage.getItem('isPushAuthorized');
    console.log('Local Storage => isPushAuthorized = ', isPushAuthorized);
    if(isPushAuthorized === null || isPushAuthorized === "false" )
        this.pushNotifications = false;
    else
      this.pushNotifications = true;
  }

}



// WEBPACK FOOTER //
// ./src/providers/preferences-service.ts